export const profileCompanyDisplay = [
  {
    type: "adminUser",
    heading: "User Details",
    details: [
      {
        disp: "0",
        header: "Member Id",
        value: "memberId",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Email",
        value: "email",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Mobile",
        value: "phone",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Username",
        value: "userName",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Full Name",
        value: "fullName",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Active Roles",
        value: "roles",
        defaultValue: "-",
      },
    ],
  },
  {
    type: "company",
    heading: "Company Details",
    details: [
      {
        disp: "0",
        header: "Holding Company",
        value: "holdingCompany",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Company Name",
        value: "companyName",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Display Name",
        value: "displayName",
        defaultValue: "-",
      },
      {
        disp: "1",
        header: "Company Description",
        value: "description",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "CategoryId",
        value: "categoryName",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Register At",
        value: "registeredAt",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "PAN Number",
        value: "pan",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "TAN Number",
        value: "tan",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "GST Number",
        value: "gst",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Trading Number",
        value: "tradingLicenseNumber",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Credit Rating",
        value: "creditRating",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Credit Year",
        value: "creditRatingYear",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Credit Agency",
        value: "creditRatingAgency",
        defaultValue: "-",
      },
    ],
  },
  {
    type: "companyOfficeAddress",
    heading: "Company Office Address",
    details: [
      {
        disp: "1",
        header: "Address",
        value: "address",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "City",
        value: "cityName",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "State",
        value: "stateUtName",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Pincode",
        value: "pinCode",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Contact Number",
        value: "mobileNumber",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Email",
        value: "email",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Alt. Contact Number",
        value: "alternateMobileNumber",
        addressType: "office",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Contact Name",
        value: "contactPersonName",
        addressType: "office",
        defaultValue: "-",
      },
    ],
  },
  {
    type: "companyCorrespondenceAddress",
    heading: "Correspondance Office Address",
    details: [
      {
        disp: "1",
        header: "Address",
        value: "address",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "City",
        value: "cityName",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "State",
        value: "stateUtName",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Pincode",
        value: "pinCode",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Contact Number",
        value: "mobileNumber",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Email",
        value: "email",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Alt. Contact Number",
        value: "alternateMobileNumber",
        addressType: "correspondence",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Contact Name",
        value: "contactPersonName",
        addressType: "correspondence",
        defaultValue: "-",
      },
    ],
  },
  {
    type: "companyBankAccount",
    heading: "Bank Details",
    details: [
      {
        disp: "1",
        header: "Bank Name",
        value: "bankName",
        defaultValue: "-",
      },
      {
        disp: "1",
        header: "Payee Name",
        value: "payee",
        defaultValue: "-",
      },
      {
        disp: "1",
        header: "Bank Address",
        value: "branchAddress",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Account Number",
        value: "accountNumber",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "IFSC Code",
        value: "ifscCode",
        defaultValue: "-",
      },
    ],
  },
  {
    type: "companyDocumentMapping",
    heading: "Documents",
    details: [
      {
        disp: "2",
        header: "PAN Proof",
        value: "panDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "TAN Proof",
        value: "tanDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "GST Proof",
        value: "gstDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "Membership Proof",
        value: "membershipFormDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "Undertaking Proof",
        value: "undertakingDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "Payment Proof",
        value: "proofOfPaymentDocId",
        defaultValue: "-",
      },
      {
        disp: "2",
        header: "Trading License Proof",
        value: "tradingLicenseDocId",
        defaultValue: "-",
      },
    ],
  },
];

export const getDisplayValue = (data, field, defaultValue = "-") => {
  const value = data?.[field.value];
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "object" && Object.keys(value).length === 0)
  ) {
    return field.defaultValue || defaultValue;
  }
  return value;
};

export const consumerDetails = {
  type: "consumer",
  heading: "consumerName",
  details: [
    // {
    //   disp: "0",
    //   header: "Consumer ID",
    //   value: "consumerId",
    //   defaultValue: "-",
    // },
    {
      disp: "0",
      header: "Consumer Name",
      value: "consumerName",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Unique ID",
      value: "uniqueId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Company ID",
      value: "companyId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Account Status",
      value: "accountStatus",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Max Capacity Drawal",
      value: "maxCapDrawl",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Point Of Drawal",
      value: "pointValue",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Specification ID",
      value: "specificationId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State UT ID",
      value: "stateUtName",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "PAN",
      value: "pan",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "TAN",
      value: "tan",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "GST",
      value: "gst",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Created At",
      value: "createdAt",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "PAN Proof",
      value: "panDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "TAN Proof",
      value: "tanDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "GST Proof",
      value: "gstDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Membership Form",
      value: "membershipFormDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Trading License",
      value: "tradingLicenseDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Undertaking Doc",
      value: "undertakingDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Proof of Payment",
      value: "proofOfPaymentDocId",
      defaultValue: "-",
    },
  ],
  bankDetails: [
    {
      disp: "1",
      header: "Bank Name",
      value: "bankName",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "1",
      header: "Payee Name",
      value: "payee",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "1",
      header: "Bank Address",
      value: "branchAddress",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Account Number",
      value: "accountNumber",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "IFSC Code",
      value: "ifscCode",
      addressType: "bank",
      defaultValue: "-",
    },
  ],
  consumerOfficeAddress: [
    {
      disp: "1",
      header: "Address",
      value: "address",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State",
      value: "stateUtName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "City",
      value: "cityName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Pincode",
      value: "pinCode",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Email",
      value: "email",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Name",
      value: "contactPersonName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Number",
      value: "mobileNumber",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Alt. Contact Number",
      value: "alternateMobileNumber",
      addressType: "office",
      defaultValue: "-",
    },
  ],
  consumerCorrespondenceAddress: [
    {
      disp: "1",
      header: "Address",
      value: "address",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State",
      value: "stateUtName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "City",
      value: "cityName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Pincode",
      value: "pinCode",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Email",
      value: "email",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Name",
      value: "contactPersonName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Number",
      value: "mobileNumber",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Alt. Contact Number",
      value: "alternateMobileNumber",
      addressType: "correspondence",
      defaultValue: "-",
    },
  ],
  discomDetails: [
    {
      disp: "0",
      header: "Discom ID",
      value: "discomId",
      addressType: "discom",
    },
    {
      disp: "0",
      header: "Voltage Level",
      value: "voltageLevel",
      addressType: "discom",
    },
  ],
};

export const generatorDetails = {
  type: "generator",
  heading: "generatorName",
  details: [
    // {
    //   disp: "0",
    //   header: "Generator ID",
    //   value: "generatorId",
    //   defaultValue: "-",
    // },
    {
      disp: "0",
      header: "Generator Name",
      value: "generatorName",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Unique ID",
      value: "uniqueId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Company ID",
      value: "companyId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Installed Capacity",
      value: "installedCap",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Max Injection Capacity",
      value: "maxInjCap",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Point Of Injection",
      value: "pointValue",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "POI Location",
      value: "poiLocation",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Energy Type Name",
      value: "energyTypeName",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Specification",
      value: "specificationName",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State",
      value: "stateUtId",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Is Commissioned",
      value: "isCommissioned",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Commissioned At",
      value: "commissionedAt",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Is ABT Exist",
      value: "isAbtExist",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Is Subsidy Received",
      value: "isSubsidyReceived",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Subsidy Type",
      value: "subsidyType",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "PAN",
      value: "pan",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "TAN",
      value: "tan",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "GST",
      value: "gst",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Created At",
      value: "createdAt",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "PAN Proof",
      value: "panDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "TAN Proof",
      value: "tanDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "GST Proof",
      value: "gstDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Membership Form",
      value: "membershipFormDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Trading License",
      value: "tradingLicenseDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Undertaking Doc",
      value: "undertakingDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Proof of Payment",
      value: "proofOfPaymentDocId",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "NOC Documents",
      value: "nocDocs",
      defaultValue: "-",
    },
    {
      disp: "2",
      header: "Other Files",
      value: "otherFiles",
      defaultValue: "-",
    },
  ],
  bankDetails: [
    {
      disp: "1",
      header: "Bank Name",
      value: "bankName",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "1",
      header: "Payee Name",
      value: "payee",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "1",
      header: "Bank Address",
      value: "branchAddress",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Account Number",
      value: "accountNumber",
      addressType: "bank",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "IFSC Code",
      value: "ifscCode",
      addressType: "bank",
      defaultValue: "-",
    },
  ],
  generatorOfficeAddress: [
    {
      disp: "1",
      header: "Address",
      value: "address",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State",
      value: "stateUtName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "City",
      value: "cityName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Pincode",
      value: "pinCode",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Email",
      value: "email",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Name",
      value: "contactPersonName",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Number",
      value: "mobileNumber",
      addressType: "office",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Alt. Contact Number",
      value: "alternateMobileNumber",
      addressType: "office",
      defaultValue: "-",
    },
  ],
  generatorCorrespondenceAddress: [
    {
      disp: "1",
      header: "Address",
      value: "address",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "State",
      value: "stateUtName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "City",
      value: "cityName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Pincode",
      value: "pinCode",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Email",
      value: "email",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Name",
      value: "contactPersonName",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Contact Number",
      value: "mobileNumber",
      addressType: "correspondence",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Alt. Contact Number",
      value: "alternateMobileNumber",
      addressType: "correspondence",
      defaultValue: "-",
    },
  ],
  discomDetails: [
    {
      disp: "0",
      header: "Discom ID",
      value: "discomId",
      addressType: "discom",
      defaultValue: "-",
    },
    {
      disp: "0",
      header: "Voltage Level",
      value: "voltageLevel",
      addressType: "discom",
      defaultValue: "-",
    },
  ],
};

export const bankingDetails = [
  {
    type: "discomDetails",
    heading: "Discom Details",
    details: [
      // {
      //   disp: "0",
      //   header: "Discom ID",
      //   value: "discomId",
      //   addressType: "discom",
      //   defaultValue: "-",
      // },
      {
        disp: "0",
        header: "Discom Name",
        value: "discomName",
        addressType: "discom",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Acronym",
        value: "acronym",
        addressType: "discom",
        defaultValue: "-",
      },
      {
        disp: "0",
        header: "Entity Type",
        value: "entityType",
        addressType: "discom",
        defaultValue: "-",
      },
    ],
  },
];
